import React from "react";
import parse from "html-react-parser";
import { Carousel } from "antd";
const MyColumnContent = (props) => {
  return (
    <div style={{ padding: "6px" }}>
      {typeof props.headdata == "string" &&
        props.headdata !== undefined &&
        parse(props.headdata)}
      <Carousel autoplay speed={1000} autoplaySpeed={5000} dots={false}>
        {props.pngdata !== undefined &&
          props.pngdata.map((el) => (
            <div>
              <img src={el.content} width="100%" />
            </div>
          ))}
      </Carousel>
      {typeof props.fooddata == "string" &&
        props.fooddata !== undefined &&
        parse(props.fooddata)}
    </div>
  );
};
export default MyColumnContent;
